import styled from '@emotion/styled'

type CenterModalProps = {
	visible: boolean
	dataList: { title?: string; desc: string; zIndex?: number }
	onComplete: () => void
	onCancel: () => void
}

const CenterModal = ({ visible, dataList, onComplete, onCancel }: CenterModalProps) => {
	if (!visible || !dataList) return null
	return (
		<BackgroundFullScreen style={{ zIndex: dataList.zIndex }}>
			<WhiteBox>
				<Content>
					<Title>{dataList.title}</Title>
					<Description>{dataList.desc}</Description>
				</Content>
				<ButtonWrapper>
					{onCancel && <CancelButton onClick={onCancel}>취소</CancelButton>}
					<Button onClick={onComplete}>확인</Button>
				</ButtonWrapper>
			</WhiteBox>
		</BackgroundFullScreen>
	)
}

const BackgroundFullScreen = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.6);
`

const WhiteBox = styled.div`
	background: #fff;
	border-radius: 0.5rem;
	width: 28.4rem;
	text-align: center;
	overflow: hidden;
`

const Content = styled.div`
	padding: 4.25rem 0;
`

const Title = styled.h3`
	font-size: 1.6rem;
	font-weight: 700;
	line-height: 2.1rem;
`

const Description = styled.p`
	font-size: 1.4rem;
	font-weight: 400;
	line-height: 2.1rem;
`

const ButtonWrapper = styled.div`
	display: flex;
`
const Button = styled.button`
	font-size: 1.6rem;
	font-weight: 700;
	line-height: 1.92rem;
	text-align: center;
	color: black;
	background-color: #ffcf19;
	border: none;
	padding: 1.8rem 0;
	width: 100%;
`

const CancelButton = styled(Button)`
	background-color: #efefef;
	color: #4e4e4e;
`

export default CenterModal
